import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const currentLanguage = i18n.language;

  const changeLanguage = (lng) => {
    // Sostituisci la lingua nella URL mantenendo il resto del path
    const pathParts = location.pathname.split('/');
    if (pathParts[1] && ['it', 'en', 'es', 'fr', 'de', 'pt'].includes(pathParts[1])) {
      pathParts[1] = lng;
    } else {
      pathParts.splice(1, 0, lng);
    }
    const newPath = pathParts.join('/') || '/';
    navigate(newPath + location.search, { replace: true });
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage('it')}
        className={currentLanguage.startsWith('it') ? 'active' : ''}
        aria-label="Italiano"
      >
        🇮🇹
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={currentLanguage.startsWith('en') ? 'active' : ''}
        aria-label="English"
      >
        🇬🇧
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={currentLanguage.startsWith('es') ? 'active' : ''}
        aria-label="Español"
      >
        🇪🇸
      </button>
      <button
        onClick={() => changeLanguage('fr')}
        className={currentLanguage.startsWith('fr') ? 'active' : ''}
        aria-label="Français"
      >
        🇫🇷
      </button>
      <button
        onClick={() => changeLanguage('de')}
        className={currentLanguage.startsWith('de') ? 'active' : ''}
        aria-label="Deutsch"
      >
        🇩🇪
      </button>
      <button
        onClick={() => changeLanguage('pt')}
        className={currentLanguage.startsWith('pt') ? 'active' : ''}
        aria-label="Português"
      >
        🇵🇹
      </button>
    </div>
  );
};

export default LanguageSwitcher;
